import { Instagram } from "lucide-react";
import { CONTACT } from "../data/content";

export default function InstagramLink({ className, iconSize = 18, showLabel = false }) {
  const defaultClass =
    "inline-flex items-center justify-center gap-2 w-10 h-10 rounded-full border border-border hover:border-accent hover:text-accent transition-colors duration-300";

  return (
    <a
      href={CONTACT.instagram}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Follow Kalpavriksha on Instagram"
      data-testid="instagram-link"
      className={className || defaultClass}
    >
      <Instagram size={iconSize} />
      {showLabel && <span className="text-sm font-medium">Instagram</span>}
    </a>
  );
}
